"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import { Select, Button, Popover, ListBox, ListBoxItem, SelectValue, Key } from "react-aria-components";
import { ChevronDown } from "lucide-react";
interface SelectOption {
  value: string;
  label: string;
}
interface TailwindSelectProps {
  options: SelectOption[];
  value?: SelectOption | null;
  placeholder?: string;
  onChange?: (option: SelectOption) => void;
  isLoading?: boolean;
  isSearchable?: boolean;
  className?: string;
}
const TailwindSelect: React.FC<TailwindSelectProps> = t0 => {
  const $ = _c(23);
  const {
    options,
    value,
    placeholder: t1,
    onChange,
    isLoading: t2,
    className: t3
  } = t0;
  const placeholder = t1 === undefined ? "Select an option" : t1;
  const isLoading = t2 === undefined ? false : t2;
  const className = t3 === undefined ? "" : t3;
  let t4;
  if ($[0] !== onChange || $[1] !== options) {
    t4 = key => {
      if (key === null) {
        return;
      }
      const selectedOption = options.find(option => option.value === key);
      if (selectedOption && onChange) {
        onChange(selectedOption);
      }
    };
    $[0] = onChange;
    $[1] = options;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  const handleSelectionChange = t4;
  const t5 = value?.value || null;
  const t6 = `t-group t-relative t-inline-block ${className}`;
  let t7;
  if ($[3] !== isLoading || $[4] !== placeholder || $[5] !== value?.label) {
    t7 = isLoading ? <span className="t-flex t-items-center t-gap-2"><div className="t-w-3 t-h-3 t-border t-border-gray-300 t-border-t-purple-600 t-rounded-full t-animate-spin" />Loading...</span> : value?.label || placeholder;
    $[3] = isLoading;
    $[4] = placeholder;
    $[5] = value?.label;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] !== t7) {
    t8 = <SelectValue className="t-text-left t-flex-1 t-truncate">{t7}</SelectValue>;
    $[7] = t7;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <ChevronDown className="t-w-4 t-h-4 t-text-[#72777D] t-transition-transform group-data-[open]:t-rotate-180" aria-hidden="true" />;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] !== t8) {
    t10 = <Button className="t-flex t-min-h-11 t-w-44 t-items-center t-justify-between t-rounded-none t-border t-border-slate-300 t-bg-white t-px-3.5 t-py-2 t-text-xs t-font-medium t-text-[#4c5054] t-shadow-sm t-transition-all hover:t-border-brand-violet-dark focus:t-outline-none focus-visible:t-ring-2 focus-visible:t-ring-brand-violet focus-visible:t-ring-offset-2 disabled:t-cursor-not-allowed disabled:t-opacity-50 sm:t-w-52" aria-label="Sort options">{t8}{t9}</Button>;
    $[10] = t8;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  let t11;
  if ($[12] !== options) {
    t11 = options.map(_temp);
    $[12] = options;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  let t12;
  if ($[14] !== t11) {
    t12 = <Popover className="t-z-50 t-mt-1 t-min-w-[208px] t-rounded-none t-border t-border-gray-200 t-bg-white t-p-1 t-shadow-lg entering:t-animate-in entering:t-fade-in entering:t-zoom-in-95 exiting:t-animate-out exiting:t-fade-out exiting:t-zoom-out-95"><ListBox className="t-outline-none">{t11}</ListBox></Popover>;
    $[14] = t11;
    $[15] = t12;
  } else {
    t12 = $[15];
  }
  let t13;
  if ($[16] !== handleSelectionChange || $[17] !== isLoading || $[18] !== t10 || $[19] !== t12 || $[20] !== t5 || $[21] !== t6) {
    t13 = <Select selectedKey={t5} onSelectionChange={handleSelectionChange} className={t6} isDisabled={isLoading}>{t10}{t12}</Select>;
    $[16] = handleSelectionChange;
    $[17] = isLoading;
    $[18] = t10;
    $[19] = t12;
    $[20] = t5;
    $[21] = t6;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  return t13;
};
export default TailwindSelect;
function _temp(option_0) {
  return <ListBoxItem key={option_0.value} id={option_0.value} textValue={option_0.label} className="t-relative t-flex t-cursor-pointer t-select-none t-items-center t-rounded-none t-px-3 t-py-2 t-text-xs t-text-gray-900 t-transition-colors hover:t-bg-[#f2e8fc] focus:t-bg-[#f2e8fc] focus:t-outline-none selected:t-bg-[#1C1D1F] selected:t-text-white data-[focused]:t-bg-[#f2e8fc] data-[selected]:t-bg-[#1C1D1F] data-[selected]:t-text-white" aria-label={`Sort by ${option_0.label}`}>{option_0.label}</ListBoxItem>;
}